import { render, staticRenderFns } from "./Chatting.vue?vue&type=template&id=c58b5bca&scoped=true"
import script from "./Chatting.vue?vue&type=script&lang=js"
export * from "./Chatting.vue?vue&type=script&lang=js"
import style0 from "./Chatting.vue?vue&type=style&index=0&id=c58b5bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58b5bca",
  null
  
)

export default component.exports